// Bloqueia ENTER apenas em dispositivos Zebra (DataWedge modo teclado/IME)
// Captura keydown/keypress/keyup e, principalmente, beforeinput(insertLineBreak)

import { useEffect } from 'react'

function isZebraUA(ua: string) {
  // alguns identificadores comuns de terminais Zebra
  return /Zebra|TC[0-9]+|EC[0-9]+|MC[0-9]+|PS20|WT6/i.test(ua)
}

export function useZebraEnterSwallow() {
  useEffect(() => {
    const ua = navigator.userAgent || ''
    if (!isZebraUA(ua)) return

    // Campos de scan (ex.: gate de presença) marcados com data-scan-passthrough
    // PRECISAM do Enter/quebra-de-linha para submeter — não os engolir. Além do
    // e.target, considerar o elemento COM FOCO: o terminador pode chegar com
    // target=body mesmo com o input de scan focado.
    const isScanPassthrough = (e: Event) => {
      const t = e.target as HTMLElement | null
      if (t?.closest?.('[data-scan-passthrough]')) return true
      const a = document.activeElement as HTMLElement | null
      return !!a?.closest?.('[data-scan-passthrough]')
    }

    // key events (quando o Enter vem como tecla)
    const onKey = (e: KeyboardEvent) => {
      if (isScanPassthrough(e)) return
      if (e.key === 'Enter' || (e as any).keyCode === 13) {
        e.preventDefault()
        e.stopImmediatePropagation?.()
        e.stopPropagation()
        return false
      }
    }

    // beforeinput (quando o IME injeta quebra de linha direto no input)
    const onBeforeInput = (e: InputEvent) => {
      if (isScanPassthrough(e)) return
      // Em Chrome/Android o Enter vira insertLineBreak
      if (e.inputType === 'insertLineBreak') {
        e.preventDefault()
        ;(e as any).stopImmediatePropagation?.()
        e.stopPropagation()
        return false
      }
    }

    // capture = true para interceptar antes de qualquer handler da app
    window.addEventListener('keydown', onKey, { capture: true })
    window.addEventListener('keypress', onKey, { capture: true })
    window.addEventListener('keyup', onKey, { capture: true })
    document.addEventListener('beforeinput', onBeforeInput as any, {
      capture: true,
    })

    return () => {
      window.removeEventListener('keydown', onKey, { capture: true } as any)
      window.removeEventListener('keypress', onKey, { capture: true } as any)
      window.removeEventListener('keyup', onKey, { capture: true } as any)
      document.removeEventListener('beforeinput', onBeforeInput as any, {
        capture: true,
      })
    }
  }, [])
}
